import { Button, Typography } from '@smartgift/frontend-toolkit';
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { PageLayout } from '@hero/components/layouts';
import { configs } from '@hero/configs';
import { CompanyLogo, DigitalWrapper, DigitalWrapperPreview, SettingsTabs } from '@hero/organisms';
import { useGetBranding, useUpdateBranding } from '@hero/services/organization-service/hooks';
import { useNotification } from '@hero/store/hooks';

import * as S from './style';

export default function BrandingPage() {
  const { t } = useTranslation();
  const { showSuccess } = useNotification();
  const { data: { branding } = {} } = useGetBranding();
  const { mutateAsync: updateBranding } = useUpdateBranding();

  const defaultGiftWrapperUrl = branding?.giftWrappers?.default;

  const [giftWrapperUrl, setGiftWrapperUrl] = useState('');

  const onSetDefault = async url => {
    await updateBranding({
      branding: { giftWrappers: { default: url } }
    });
    await showSuccess({
      message: <Trans i18nKey="defaultGiftWrapSuccess" components={{ b: <b /> }} />,
      type: 'toast'
    });
  };

  useEffect(() => {
    setGiftWrapperUrl(defaultGiftWrapperUrl);
  }, [defaultGiftWrapperUrl]);

  return (
    <PageLayout
      header={{
        title: t('settings')
      }}
    >
      <SettingsTabs />
      <S.Branding>
        <S.BrandingCard>
          <CompanyLogo />
        </S.BrandingCard>
        {configs?.advanceSettings?.digitalWrapperEnabled && (
          <S.DigitalWrapperContainer>
            <S.DigitalWrapperCard>
              <S.TitleWrapper>
                <Typography variant="body1Bold">{t('digitalGiftWrap')}</Typography>
              </S.TitleWrapper>
              <DigitalWrapper
                onUpdateData={({ giftWrapperUrl }) => setGiftWrapperUrl(giftWrapperUrl)}
                onSelectGiftWrapperUrl={setGiftWrapperUrl}
              />
            </S.DigitalWrapperCard>
            <S.DigitalWrapperPreview>
              <DigitalWrapperPreview giftWrapperUrl={giftWrapperUrl} />
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => onSetDefault(giftWrapperUrl)}
              >
                {t('setAsDefault')}
              </Button>
            </S.DigitalWrapperPreview>
          </S.DigitalWrapperContainer>
        )}
      </S.Branding>
    </PageLayout>
  );
}
